module.exports = __webpack_public_path__ + "img/noti4.09126eac.jpeg";